import { Helmet } from 'react-helmet';

import Layout                     from '../../components/Layout.jsx';
import CoverImage                 from '../../components/blocks/CoverImage.jsx';
import { findAssetByTitle }       from '../../helpers.js';
import IntroductionHeadline       from '../../components/blocks/IntroductionHeadline.jsx';
import Push                       from '../../components/blocks/Push.jsx';
import KeepExploringDefault       from '../../modules/KeepExploringDefault.jsx';
import useRolexAtRetailerPageData from '../../hooks/useRolexAtRetailerPageData.js';
import Loading                    from '../../components/Loading.jsx';
import Analytics                  from '../../components/Analytics.jsx';
import Canonical                  from '../../components/Canonical.jsx';

const RolexAtRetailerPage = (props) => {
  const { data, isLoading, error, pushElements } = useRolexAtRetailerPageData(props.apikey);


  if (isLoading) return <Loading/>;
  if (error) return <div>Error...</div>;


  return (
    <>
      {data &&
        <>
          <Helmet>
            <title>Rolex in {data.rlx_retailer[0].retailer_location} | {data.rlx_retailer[0].retailer_name}</title>
            <meta name="description"
                  content={`Entdecken Sie Rolex bei ${data.rlx_retailer[0].retailer_name}. Entdecken Sie unsere Auswahl an Luxusuhren von
Rolex und erfahren Sie mehr über unseren Rolex Verkaufsraum, unser Rolex Team und unsere Geschichte
mit Rolex.`}/>
            <meta name="keywords" content={`Rolex in ${data.rlx_retailer[0].retailer_location}`}/>
          </Helmet>
          <Canonical route="rolex-at"/>
        </>
      }
      <Analytics pageType="rolex at page"/>
      <Layout>
        <section>
          <CoverImage image={findAssetByTitle('cover-2', data.rlx_page[0].page_assets).rlx_responsive_asset_id}/>
        </section>
        <section className="my-[8vh]">
          <IntroductionHeadline headline={`Rolex bei ${data.rlx_retailer[0].retailer_name}`}>
            <p><b>Latius fama vulgasset missaeque relationes adsiduae Gallum Caesarem permovissent, quoniam magister
              equitum longius ea.</b> Tempestate distinebatur, iussus comes orientis nebridius contractis undique
              militaribus copiis ad eximendam periculo civitatem.</p>
          </IntroductionHeadline>
        </section>
        <section className="mt-[8vh]">
          <Push heading={pushElements.showrooms.heading} elements={pushElements.showrooms.elements}
                assets={data.rlx_page[0].page_assets}/>
        </section>
        <section className="my-[8vh]">
          <Push heading={pushElements.teamAndHistory.heading} elements={pushElements.teamAndHistory.elements}
                assets={data.rlx_page[0].page_assets}/>
        </section>
        <section className="py-[8vh] bg-white">
          <KeepExploringDefault/>
        </section>
      </Layout>
    </>
  );
}

export default RolexAtRetailerPage;
